export const PERMISSION = {
    EDIT_TIPE_PELUNASAN: {
        APPROVAL: 'AET',
        REJECT: 'AET',
        REQUEST: 'RET',
    },
    LELANG_PACKING: 'LPO',
    LELANG_PACKING_RESET_CAPABILITIES: 'LRC',
}